import { render, staticRenderFns } from "./TopInvestors.vue?vue&type=template&id=947b1eca&scoped=true&"
import script from "./TopInvestors.vue?vue&type=script&lang=ts&"
export * from "./TopInvestors.vue?vue&type=script&lang=ts&"
import style0 from "./TopInvestors.vue?vue&type=style&index=0&id=947b1eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947b1eca",
  null
  
)

export default component.exports